module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"interviews":"Interviews","sms":"Text messages","calls":"Calls","from":"out of","add":"Add"}}')
  delete Component.options._Ctor
}
